import { parseJSON } from "./parseJSON";
import { getToken } from "../utils/authUtils";

const urlBase = `${process.env.API_URL}`;
const readUrl = (url = "") => `${urlBase}/${url}`;

export const getQRCode = async ({ userName, password }) => {
  const encodedUserName = encodeURIComponent(userName);
  const encodedPassword = encodeURIComponent(password);
  let res = await fetch(readUrl(`authenticator2fa/getCodes?email=${encodedUserName}&service=Adecco-PIN&userName=${encodedUserName}&password=${encodedPassword}`), {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  });

  res = await parseJSON(res);

  return res;
};

export const postVerifyQrCode = async (token, email, password) => {
  const auth = `Bearer ${getToken()}`;
  let res = await fetch(readUrl("authenticator2fa/verifyAuthenticator"), {
    method: "POST",
    headers: {
      Accept: "application/json",
      Authorization: auth,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ token, email, password }),
  });

  res = await res.json();

  return res;
};
export const postVerifyQrCodeWhithToken = async (token) => {
  const auth = `Bearer ${getToken()}`;
  let res = await fetch(readUrl("authenticator2fa/verifyAuthWithToken"), {
    method: "POST",
    headers: {
      Accept: "application/json",
      Authorization: auth,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ token }),
  });

  res = await res.json();

  return res;
};

export const getBackupCode = async () => {
  const auth = `Bearer ${getToken()}`;
  let res = await fetch(readUrl(`authenticator2fa/backupCode`), {
    method: "GET",
    headers: {
      Accept: "application/json",
      Authorization: auth,
      "Content-Type": "application/json",
    },
  });

  res = await parseJSON(res);

  return res;
};

// no tengo token ni user id
export const postVerifyBackupCode = async (code, userId) => {
  const auth = `Bearer ${getToken()}`;
  let res = await fetch(readUrl("authenticator2fa/verifyBackupCode"), {
    method: "POST",
    headers: {
      Accept: "application/json",
      Authorization: auth,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ code, userId }),
  });

  res = await res.json();

  return res;
};

// export const postForgotPassword = async ({ email }) => {
//   let res = await fetch(readUrl("forgot"), {
//     method: "POST",
//     headers: {
//       "Content-Type": "application/json",
//     },
//     body: JSON.stringify({ email }),
//   });

//   res = await parseJSON(res);

//   return res.success;
// };

// export const postResetPassword = async ({ email, code, password, verification }) => {
//   let res = await fetch(readUrl("reset"), {
//     method: "POST",
//     headers: {
//       "Content-Type": "application/json",
//     },
//     body: JSON.stringify({ email, code, password, verification }),
//   });

//   res = await parseJSON(res);

//   return res.success;
// };

// export const fetchAccess = async () => {
//   const auth = `Bearer ${getToken()}`;

//   let res = await fetch(readUrl("access"), {
//     method: "GET",
//     headers: {
//       Accept: "application/json",
//       Authorization: auth,
//       "Content-Type": "application/json",
//     },
//   });

//   res = await parseJSON(res);

//   return res.success;
// };
